<template>
  <div class="vd-gl-content">
    <a-list
      rowKey="id"
      :grid="{ gutter: 24, lg: 3, md: 2, sm: 1, xs: 1 }"
      :dataSource="dataSource"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <template>
          <a-card :hoverable="true">
            <a-card-meta>
              <a slot="title">{{ item.name }}</a>
              <a-avatar slot="avatar" icon="setting" size="large" />
              <div
                class="vd-card-description"
                slot="description"
                style="word-break: break-word"
              >
                {{ item.description }}
              </div>
            </a-card-meta>
            <template class="ant-card-actions" slot="actions">
              <div @click="jump(item.url)">
                <a-icon type="more" />
                详情
              </div>
            </template>
          </a-card>
        </template>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      dataSource: [
        {
          name: 'Excel转化工具',
          description: '活动名单转化为按照地市分类的名单',
          url: '/tool/standard_excel',
        },
        {
          name: 'QQ数据导出',
          description: 'QQ数据导出',
          url: '/tool/qq_group_excel',
        },
      ],
    }
  },
  methods: {
    jump(key) {
      this.$router.push({ path: key, replace: true })
    },
  },
}
</script>

<style scoped></style>
